import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgSigma = ({
  color,
  alt,
  "aria-roledescription": roleDescription = "Sigma",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <path
      d="M11.5001 4.5V3.5H5.04069L8.39069 7.6875C8.4617 7.77618 8.50038 7.8864 8.50038 8C8.50038 8.1136 8.4617 8.22382 8.39069 8.3125L5.04069 12.5H11.5001V11.5C11.5001 11.3674 11.5527 11.2402 11.6465 11.1464C11.7403 11.0527 11.8675 11 12.0001 11C12.1327 11 12.2599 11.0527 12.3536 11.1464C12.4474 11.2402 12.5001 11.3674 12.5001 11.5V13C12.5001 13.1326 12.4474 13.2598 12.3536 13.3536C12.2599 13.4473 12.1327 13.5 12.0001 13.5H4.00007C3.90584 13.5001 3.81352 13.4735 3.73373 13.4234C3.65395 13.3732 3.58996 13.3016 3.54913 13.2166C3.5083 13.1317 3.4923 13.037 3.50297 12.9434C3.51364 12.8498 3.55055 12.7611 3.60944 12.6875L7.35944 8L3.60944 3.3125C3.55055 3.23894 3.51364 3.15025 3.50297 3.05663C3.4923 2.963 3.5083 2.86827 3.54913 2.78335C3.58996 2.69843 3.65395 2.62677 3.73373 2.57664C3.81352 2.52651 3.90584 2.49994 4.00007 2.5H12.0001C12.1327 2.5 12.2599 2.55268 12.3536 2.64645C12.4474 2.74022 12.5001 2.86739 12.5001 3V4.5C12.5001 4.63261 12.4474 4.75979 12.3536 4.85355C12.2599 4.94732 12.1327 5 12.0001 5C11.8675 5 11.7403 4.94732 11.6465 4.85355C11.5527 4.75979 11.5001 4.63261 11.5001 4.5Z"
      fill="#1B4254"
    />
  </svg>
);

const Sigma = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgSigma />
  </BaseIcon>
);

export default Sigma;
